function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "22.106px",
    viewBox: "0 0 100 100"
  }, props), _ref, React.createElement("path", {
    className: "cls-1",
    d: "M63.62,57.73A16.85,16.85,0,1,1,46.78,40.89",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeWidth": 3
    }
  }), React.createElement("polygon", {
    className: "cls-1",
    points: "63.62 46.58 57.17 56.91 70.06 56.91 63.62 46.58",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeWidth": 3
    }
  }), React.createElement("path", {
    className: "cls-1",
    d: "M24.22,83.2h0a36.45,36.45,0,0,1,0-51.56L50,5.86,75.78,31.64a36.45,36.45,0,0,1,0,51.56h0A36.45,36.45,0,0,1,24.22,83.2Z",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeWidth": 3
    }
  }));
};

export default __webpack_public_path__ + "static/media/job_eco_friendly.59e8838b.svg";
export { SvgComponent as ReactComponent };